import { useEffect, useState } from "react";
import { Progress } from "components/ui/progress";
import { cn } from "@/lib/utils";
import { isFailureStatus } from "./utils";

interface LinearProgressWithLabelProps {
  value: number;
  status: string;
}

function LinearProgressWithLabel({
  value,
  status,
}: LinearProgressWithLabelProps) {
  const [counter, setCounter] = useState(0);

  useEffect(() => {
    if (status !== "Running") return;
    const interval = setInterval(() => setCounter((prev) => prev + 2), 10);
    return () => clearInterval(interval);
  }, [status]);

  const isFailure = isFailureStatus(status);

  const indicatorStyle =
    status === "Running"
      ? ({
          "--progress-color": `hsl(${counter}, 100%, 50%)`,
        } as React.CSSProperties)
      : undefined;

  return (
    <div className="flex items-center w-full h-full">
      <div className="w-full mr-2">
        <Progress
          value={value}
          className={cn(
            "h-5 rounded-sm",
            isFailure
              ? "**:data-[slot=progress-indicator]:bg-muted-foreground"
              : status === "Running"
                ? "**:data-[slot=progress-indicator]:bg-(--progress-color)"
                : "**:data-[slot=progress-indicator]:bg-info",
          )}
          style={indicatorStyle}
        />
      </div>
      <div className="min-w-9">
        {!isFailure && (
          <span className="text-xs text-muted-foreground">
            {`${Math.round(value)}%`}
          </span>
        )}
      </div>
    </div>
  );
}

export { LinearProgressWithLabel };
